export const BREWERY_FILTER_ANY = '__any__';

export function breweryBeerFilterStorageKey(breweryGroupId) {
  const normalized =
    typeof breweryGroupId === 'string' ? breweryGroupId.trim() : '';
  if (!normalized) {
    return '';
  }
  return `breweryBeers.breweryFilter.${normalized}`;
}

/**
 * @param {string} storedValue
 * @param {{ parentBreweryId: string, groupMemberIds: string[] }} context
 * @returns {string}
 */
export function resolveValidBreweryFilterValue(storedValue, context) {
  const { parentBreweryId, groupMemberIds } = context;
  if (!parentBreweryId) {
    return parentBreweryId;
  }
  if (storedValue === BREWERY_FILTER_ANY) {
    return BREWERY_FILTER_ANY;
  }
  if (storedValue === parentBreweryId) {
    return parentBreweryId;
  }
  if (groupMemberIds.includes(storedValue)) {
    return storedValue;
  }
  return parentBreweryId;
}

export function readBreweryFilterFromSession(storageKey, context) {
  if (!storageKey || !context.parentBreweryId) {
    return context.parentBreweryId;
  }
  try {
    const stored = sessionStorage.getItem(storageKey);
    if (!stored) {
      return context.parentBreweryId;
    }
    return resolveValidBreweryFilterValue(stored, context);
  } catch {
    return context.parentBreweryId;
  }
}

export function writeBreweryFilterToSession(storageKey, filterValue) {
  if (!storageKey || !filterValue) {
    return;
  }
  try {
    sessionStorage.setItem(storageKey, filterValue);
  } catch {
    // ignore quota / private mode
  }
}

/**
 * @param {object} beer
 * @param {string[]} scopeBreweryIds
 * @returns {boolean}
 */
export function beerMatchesBreweryScope(beer, scopeBreweryIds) {
  if (!Array.isArray(scopeBreweryIds) || scopeBreweryIds.length === 0) {
    return true;
  }
  const availableIds = Array.isArray(beer?.availableBreweryIds)
    ? beer.availableBreweryIds
    : [];
  return scopeBreweryIds.some((scopeId) => availableIds.includes(scopeId));
}

/**
 * @param {object} beer
 * @param {string} filterBreweryId
 * @returns {boolean}
 */
export function beerMatchesBreweryFilter(beer, filterBreweryId) {
  if (filterBreweryId === BREWERY_FILTER_ANY) {
    return true;
  }
  const ids = Array.isArray(beer.availableBreweryIds)
    ? beer.availableBreweryIds
    : [];
  return ids.includes(filterBreweryId);
}
